export const getOrganizationName = ({ name } = {}) => name.charAt(0)

export const getOrganizationAvatar = ({ logoURL } = {}) => logoURL || null
